import React, { useState } from 'react';
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';

const LeadForm = (props) => {
  const {
    lead = {
      contactName: '',
      designation: '',
      contactPhone: '',
      contactEmail: '',
      contactLinkedIn: '',
      source: '',
      companyName: '',
      companyWebsite: '',
      companyLinkedIn: '',
      city: '',
      localities: '',
      seatsNeeded: '',
      requirements: '',
      status: '',
      category: '',
      lastActionDate: '',
      nextActionDate: '',
      notes: [],

    },
    handleChange,
    formErrors = {},
    statusOptions = [],
    categoryOptions = [],
    sourceOptions = [],
    cityOptions = [],
    onNoteChange,
    onAddNote,
    onRemoveNote,
    onEditNote,
    handleSubmit,
    handleClose,
    open,
    title,
    mode
  } = props;

  const isFormEditable = mode !== 'view'; // Assuming 'view' mode means non-editable

  console.log(lead, "lead")

  const [openNotesDialog, setOpenNotesDialog] = useState(false);
  const [noteDateTime, setNoteDateTime] = useState(new Date().toISOString().slice(0, 16));
  const [noteText, setNoteText] = useState('');
  const [noteDialogOpen, setNoteDialogOpen] = useState(false);
  const [currentNote, setCurrentNote] = useState([{
    dateTime: new Date().toLocaleString(),
    notes: ''
  }]);
  const [editingNoteIndex, setEditingNoteIndex] = useState(null);
  const [editingNoteText, setEditingNoteText] = useState('');

  console.log(currentNote, "currentNote")

  const handleAddNote = () => {
    setEditingNoteIndex(null); // Ensure we are in "add" mode
    setNoteText(''); // Clear any previous note text
    // setCurrentNote({ dateTime: new Date().toLocaleString(), note: '' }); // Reset currentNote if still used for adding
    setNoteDialogOpen(true);
  };

  const handleSaveNote = () => {
    if (currentNote.note.trim()) {
      const existingNotes = Array.isArray(lead.notes) ? lead.notes : [];
      const updatedNotes = [...existingNotes, {
        dateTime: currentNote.dateTime,
        note: currentNote.note.trim()
      }];

      // Update the lead's notes array
      handleChange('notes')({
        target: {
          value: updatedNotes
        }
      });

      setNoteDialogOpen(false);
      setCurrentNote({
        dateTime: new Date().toLocaleString(),
        note: ''
      });
    }
  };

  const handleDeleteNote = (index) => {
    const updatedNotes = [...lead.notes];
    updatedNotes.splice(index, 1);
    handleChange('notes')({ target: { value: updatedNotes } });
  };

  const handleEditNote = (index) => {
    setEditingNoteIndex(index);
    setNoteText(lead.notes[index].note); // Pre-fill noteText for the dialog
    setNoteDialogOpen(true);
  };

  const handleUpdateNote = () => {
    if (editingNoteIndex !== null && noteText.trim() !== '') {
      const updatedNotes = lead.notes.map((note, index) =>
        index === editingNoteIndex ? { ...note, note: noteText.trim() } : note
      );
      handleChange('notes')({ target: { value: updatedNotes } });
      setNoteDialogOpen(false);
      setEditingNoteIndex(null);
      setEditingNoteText('');
      setNoteText(''); // Reset noteText
    }
  };

  const handleSaveNewNote = () => {
    if (noteText.trim()) {
      const existingNotes = Array.isArray(lead.notes) ? lead.notes : [];
      const updatedNotes = [...existingNotes, {
        dateTime: new Date().toLocaleString(),
        note: noteText.trim()
      }];

      // Update the lead's notes array
      handleChange('notes')({
        target: {
          value: updatedNotes
        }
      });

      setNoteDialogOpen(false);
      setNoteText('');
    }
  };

  const handleCloseNoteDialog = () => {
    setNoteDialogOpen(false);
    setEditingNoteIndex(null); // Reset editing state
    setEditingNoteText('');
    setNoteText(''); // Clear note text from dialog
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
      {/* 1. Contact Information */}
      <Typography variant="subtitle2" color="textSecondary">Contact Information</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Contact Name"
            value={lead.contactName}
            onChange={(e) => handleChange('contactName')(e)}
            error={!!formErrors.contactName}
            required
          />
          {formErrors.contactName && (
            <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1 }}>
              {formErrors.contactName}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Designation"
            value={lead.designation}
            onChange={(e) => handleChange('designation')(e)}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Contact Number"
            value={lead.contactPhone}
            onChange={(e) => handleChange('contactPhone')(e)}
            error={!!formErrors.contactPhone}
            required
          />
          {formErrors.contactPhone && (
            <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1 }}>
              {formErrors.contactPhone}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Email"
            value={lead.contactEmail}
            onChange={(e) => handleChange('contactEmail')(e)}
            error={!!formErrors.contactEmail}
            required
          />
          {formErrors.contactEmail && (
            <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1 }}>
              {formErrors.contactEmail}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Contact LinkedIn"
            value={lead.contactLinkedIn}
            onChange={(e) => handleChange('contactLinkedIn')(e)}
            placeholder="https://linkedin.com/in/"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <FormControl fullWidth required error={!!formErrors.source}>
            <InputLabel>Source</InputLabel>
            <Select
              value={lead.source}
              onChange={(e) => handleChange('source')(e)}
              label="Source"
            >
              {sourceOptions.map((option) => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))}
            </Select>
          </FormControl>
          {formErrors.source && (
            <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1 }}>
              {formErrors.source}
            </Typography>
          )}
        </Grid>
      </Grid>

      {/* 2. Company Information */}
      <Typography variant="subtitle2" color="textSecondary" sx={{ mt: 2 }}>Company Information</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Company Name"
            value={lead.companyName}
            onChange={(e) => handleChange('companyName')(e)}
            error={!!formErrors.companyName}
            required
          />
          {formErrors.companyName && (
            <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1 }}>
              {formErrors.companyName}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Company Website"
            value={lead.companyWebsite}
            onChange={(e) => handleChange('companyWebsite')(e)}
            placeholder="https://"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Company LinkedIn"
            value={lead.companyLinkedIn}
            onChange={(e) => handleChange('companyLinkedIn')(e)}
            placeholder="https://linkedin.com/company/"
          />
        </Grid>
      </Grid>

      {/* 3. Requirement */}
      <Typography variant="subtitle2" color="textSecondary" sx={{ mt: 2 }}>Requirement</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <FormControl fullWidth required error={!!formErrors.city}>
            <InputLabel>City</InputLabel>
            <Select
              value={lead.city}
              onChange={(e) => handleChange('city')(e)}
              label="City"
            >
              {cityOptions.map((option) => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))}
            </Select>
          </FormControl>
          {formErrors.city && (
            <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1 }}>
              {formErrors.city}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            label="Localities"
            value={lead.localities}
            onChange={(e) => handleChange('localities')(e)}
            error={!!formErrors.localities}
            required
          />
          {formErrors.localities && (
            <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1 }}>
              {formErrors.localities}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            label="Seats Needed"
            value={lead.seatsNeeded}
            onChange={(e) => handleChange('seatsNeeded')(e)}
            error={!!formErrors.seatsNeeded}
            required
            type="number"
          />
          {formErrors.seatsNeeded && (
            <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1 }}>
              {formErrors.seatsNeeded}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            label="Requirements"
            value={lead.requirements}
            onChange={(e) => handleChange('requirements')(e)}
            error={!!formErrors.requirements}
            required
          />
          {formErrors.requirements && (
            <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1 }}>
              {formErrors.requirements}
            </Typography>
          )}
        </Grid>
      </Grid>

      {/* 4. Lead Status */}
      <Typography variant="subtitle2" color="textSecondary" sx={{ mt: 2 }}>Lead Status</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <FormControl fullWidth required error={!!formErrors.status}>
            <InputLabel>Status</InputLabel>
            <Select
              value={lead.status}
              onChange={(e) => handleChange('status')(e)}
              label="Status"
            >
              {statusOptions.map((option) => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))}
            </Select>
          </FormControl>
          {formErrors.status && (
            <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1 }}>
              {formErrors.status}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} md={3}>
          <FormControl fullWidth required error={!!formErrors.category}>
            <InputLabel>Category</InputLabel>
            <Select
              value={lead.category}
              onChange={(e) => handleChange('category')(e)}
              label="Category"
            >
              {categoryOptions.map((option) => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))}
            </Select>
          </FormControl>
          {formErrors.category && (
            <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1 }}>
              {formErrors.category}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            label="Last Action Date"
            type="date"
            value={lead.lastActionDate}
            onChange={(e) => handleChange('lastActionDate')(e)}
            InputLabelProps={{ shrink: true }}
            error={!!formErrors.lastActionDate}
            required
          />
          {formErrors.lastActionDate && (
            <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1 }}>
              {formErrors.lastActionDate}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            label="Next Action Date"
            type="date"
            value={lead.nextActionDate}
            onChange={(e) => handleChange('nextActionDate')(e)}
            InputLabelProps={{ shrink: true }}
            error={!!formErrors.nextActionDate}
            required
          />
          {formErrors.nextActionDate && (
            <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1 }}>
              {formErrors.nextActionDate}
            </Typography>
          )}
        </Grid>
      </Grid>

      {/* 5. Notes */}
      <Box sx={{ mt: 3 }}>
        <Typography variant="h6">Notes</Typography>
        <TableContainer component={Paper} sx={{ mt: 2, mb: 2 }}>
          <Table>
            <TableHead sx={{ backgroundColor: (theme) => `${theme.palette.primary.main}08` }}>
              <TableRow >
                <TableCell
                  sx={{
                    width: '25%',
                    borderBottom: '1px solid #e0e0e0',
                    py: 2
                  }}
                >
                  <Typography sx={{ fontWeight: 'bold' }}>
                    Date-Time <span style={{ color: '#f44336' }}>*</span>
                  </Typography>
                </TableCell>
                <TableCell
                  sx={{
                    borderBottom: '1px solid #e0e0e0',
                    py: 2
                  }}
                >
                  <Typography sx={{ fontWeight: 'bold' }}>
                    Notes <span style={{ color: '#f44336' }}>*</span>
                  </Typography>
                </TableCell>
                <TableCell
                  sx={{
                    borderBottom: '1px solid #e0e0e0',
                    py: 2,
                    textAlign: 'center'
                  }}
                >
                  <Typography sx={{ fontWeight: 'bold' }}>Actions</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(lead.notes) && lead.notes.map((note, index) => (
                <TableRow
                  key={index}
                  sx={{
                    '&:last-child td': { borderBottom: 0 },
                    backgroundColor: 'white'
                  }}
                >
                  <TableCell
                    sx={{
                      borderBottom: '1px solid #e0e0e0',
                      py: 2
                    }}
                  >
                    {note.dateTime}
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom: '1px solid #e0e0e0',
                      py: 2
                    }}
                  >
                    {note.note}
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom: '1px solid #e0e0e0',
                      py: 2,
                      textAlign: 'center'
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleEditNote(index)}
                      color="primary"
                      disabled={!isFormEditable}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleDeleteNote(index)} // Placeholder for delete handler
                      color="error"
                      disabled={!isFormEditable}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: 2, mb: 2 }}>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleAddNote} // This function should set editingNoteIndex to null
            disabled={!isFormEditable}
          >
            Add Note
          </Button>
        </Box>

        {/* Add/Edit Note Dialog */}
        <Dialog open={noteDialogOpen} onClose={handleCloseNoteDialog} fullWidth maxWidth="sm">
          <DialogTitle>{editingNoteIndex !== null ? 'Edit Note' : 'Add New Note'}</DialogTitle>
          <DialogContent>
            <TextField
              label="Note"
              name="note"
              value={noteText} // Uses noteText, which is set by handleEditNote or handleNoteChange
              onChange={(e) => setNoteText(e.target.value)} // Directly update noteText
              fullWidth
              multiline
              rows={4}
              margin="normal"
              // Removed error and helperText for brevity, can be added back if needed
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseNoteDialog}>Cancel</Button>
            <Button onClick={editingNoteIndex !== null ? handleUpdateNote : handleSaveNewNote} color="primary">
              {editingNoteIndex !== null ? 'Save Changes' : 'Save Note'}
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
};

export default LeadForm;
